<template>
  <div id="verifyEFOSComponent">
    <page-title :heading=heading :subheading=subheading :icon=icon :extra=extra></page-title>
    <v-container>
      <v-layout wrap>
        <v-flex xs6 sm6 md6>
          <h3>* {{$t('verifyEFOS.searchInfo')}}</h3>
          <v-form
            lazy-validation
            ref="form"
            v-model="valid"
          >
            <v-text-field
              class="w-300p"
              mask="NNNNNNNNNNNNN"
              v-model="searchTax"
              :label="$t('verifyEFOS.searchByTax')"
              box
              append-icon="search"
              clearable
              @click:append="getTaxResults"
              @keyup.enter="getTaxResults"
              :rules="rules.taxRules"
              :error-messages="errors.rfc">
            </v-text-field>
          </v-form>
        </v-flex>
        <v-flex xs6 sm6 md6 class="text-sm-right">
          <h3>* {{ $t('verifyEFOS.verifyCFDIS') }}</h3>
          <v-btn
            color="primary"
            outline
            round
            @click="getGeneralResults"
          >
            <v-icon left>playlist_add_check</v-icon> {{$t('verifyEFOS.start')}}
          </v-btn>
        </v-flex>
      </v-layout>
      <b-alert class="py-4 px-0" :show="taxWarning" variant="danger">
        <v-layout class="align-center">
          <v-flex xs1 class="text-xs-center">
            <v-icon size="40px" class="alert-link">fa-exclamation-triangle</v-icon>
          </v-flex>
          <v-flex xs11>
            <h1 class="font-weight-black">¡{{$t('general.warning')}}!</h1>
            <h3>{{$t('verifyEFOS.taxWarning', {taxID: taxResult.tax_id ? taxResult.tax_id : ''})}}</h3>
            <h3 class="mb-0"><span class="font-weight-black">{{$t('general.status')}}:</span> "{{taxResult.status ? taxResult.status : ''}}"</h3>
          </v-flex>
        </v-layout>
      </b-alert>
      <b-alert class="py-4 px-0" :show="taxSuccess" variant="success">
        <v-layout class="align-center">
          <v-flex xs1 class="text-xs-center">
            <v-icon size="40px" class="alert-link">fa-check</v-icon>
          </v-flex>
          <v-flex xs11>
            <h1 class="font-weight-black">¡{{$t('general.success')}}!</h1>
            <h3 class="mb-0">{{$t('verifyEFOS.taxSuccess', {taxID: taxResult})}}</h3>
          </v-flex>
        </v-layout>
      </b-alert>
      <v-data-table
      v-if="cfdisTable"
      class="elevation-2"
      :headers="headers"
      :items="blacklist"
      :rows-per-page-items="[10,15,25]"
      :pagination.sync="pagination"
      >
        <template v-slot:headers="props">
          <tr class="bg-heavy-rain">
            <th
            v-for="header in props.headers"
            :key="header.text"
            :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              <h2 class="font-weight-black primary--text mb-0">
                <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                {{header.text}}</h2>
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr>
            <td class="text-sm-center">{{props.item.user.name}}</td>
            <td class="text-sm-center">{{props.item.uuid}}</td>
            <td class="text-sm-center">{{props.item.serie}}</td>
            <td class="text-sm-center">{{props.item.folio}}</td>
            <td class="text-sm-center">{{props.item.date}}</td>
            <td class="text-sm-center">{{props.item.total | formatCurrency}}</td>
            <td class="text-sm-center">{{props.item.blackList ? props.item.blackList.status : ''}}</td>
            <td class="text-sm-center text-justify">
              <v-layout row justify-center>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      color="info"
                      outline
                      small
                      icon
                      @click="readXmlToHtml(props.item)">
                      <v-icon small>visibility</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('expenseItems.watchFile') }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      color="info"
                      outline
                      small
                      icon
                      @click="downloadFile(props.item)">
                      <v-icon small>get_app</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('general.download') }}</span>
                </v-tooltip>
              </v-layout>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          <v-layout>
            <v-flex class="text-sm-center">
              {{$t('verifyEFOS.noData')}}
            </v-flex>
          </v-layout>
        </template>
      </v-data-table>
      <v-dialog v-model="filterDialog" max-width="300px">
        <v-card>
          <v-card-text>
            <v-layout wrap class="my-4">
              <v-flex xs12 sm12 md12 class="text-sm-center mb-4">
                <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </v-flex>
              <v-flex xs12 sm12 md12 class="text-sm-center">
                <h2>{{$t('general.searching')}}...</h2>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="alertDialog" max-width="450px">
        <v-card>
          <v-card-text>
            <v-layout wrap v-if="blacklist.length > 0">
              <v-flex xs12 class="text-right">
                <v-btn
                  @click="alertDialog = !alertDialog"
                  color="primary"
                  flat
                  round
                  icon
                ><v-icon>close</v-icon></v-btn>
              </v-flex>
              <v-flex xs12 class="text-center">
                <img width="300px" src="../assets/images/illustrations/alert.svg">
              </v-flex>
              <v-flex xs12>
                <h1 class="mt-3 font-weight-black text-center text-danger">¡{{$t('general.warning')}}!</h1>
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="blacklist.length === 0">
              <v-flex xs12 class="text-right">
                <v-btn
                  @click="alertDialog = !alertDialog"
                  color="primary"
                  flat
                  round
                  icon
                ><v-icon>close</v-icon></v-btn>
              </v-flex>
              <v-flex xs12 class="text-center">
                <img width="200px" src="../assets/images/illustrations/success.svg">
              </v-flex>
              <v-flex xs12>
                <h1 class="mt-3 font-weight-black text-center primary--text">¡{{$t('general.success')}}!</h1>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <h3 v-if="blacklist.length > 0"  class="my-2 text-center">{{$t('verifyEFOS.hasData')}}</h3>
            <h3 v-if="blacklist.length === 0" class="my-2 text-center">{{$t('verifyEFOS.noData')}}</h3>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        persistent
        v-model="cfdiDialog"
        scrollable
        max-width="900px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">{{ $t('expenseItems.fiscal') }}</h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <v-layout>
              <v-flex xs12 class="text-sm-center my-5" v-if="!cfdiHtml">
                <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
                <h2 class="mt-4">{{$t('general.loading')}}...</h2>
              </v-flex>
            </v-layout>
            <iframe id="cfdi" name="cfdi" v-if="cfdiHtml" :srcdoc="cfdiHtml" style="width:845px; height:1200px; border:0"></iframe>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :disabled="!cfdiHtml" round flat color="primary" @click="sendToPrint()"><v-icon left>print</v-icon> {{$t('general.print')}}</v-btn>
            <v-btn
              color="primary darken-1"
              round
              depressed
              @click="close"
            >
              {{ $t('general.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
export default {
  name: 'verifyEFOSComponent',
  data () {
    return {
      blacklist: [],
      searchTax: '',
      taxResult: '',
      alertDialog: false,
      taxSuccess: false,
      taxWarning: false,
      cfdisTable: false,
      errors: {},
      cfdiHtml: null,
      loading: false,
      valid: true,
      cfdiDialog: false,
      filterDialog: false,
      pagination: {
        sortBy: 'date',
        descending: true,
        page: 1,
        rowsPerPage: 15, // -1 for All",
        totalItems: 0
      },
      editedItem: {
        taxId: ''
      },
      defaultItem: {
        taxId: ''
      }
    }
  },
  watch: {
    byTax () {
      if (this.byTax) {
        this.byGeneral = false
      }
    },
    byGeneral () {
      if (this.byGeneral) {
        this.byTax = false
      }
    },
    cfdisTable () {
      if (this.cfdisTable) {
        this.alertDialog = true
      }
    }
  },
  computed: {
    heading () {
      return this.$t('general.verifyEFOS')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'fa fa-tasks fa-fw icon-color'
    },
    extra () {
      return this.$t('verifyEFOS.subheader')
    },
    headers () {
      return [
        {
          text: this.$t('general.employee'),
          align: 'center',
          value: 'user.name',
          sortable: true
        },
        {
          text: 'UUID',
          align: 'center',
          value: 'uuid',
          sortable: true
        },
        {
          text: this.$t('verifyEFOS.set'),
          align: 'center',
          value: 'serie',
          sortable: true
        },
        {
          text: this.$t('general.folio'),
          align: 'center',
          value: 'folio',
          sortable: true
        },
        {
          text: this.$t('general.certifiedDate'),
          align: 'center',
          value: 'date',
          sortable: true
        },
        {
          text: this.$t('restriction.rt.amount'),
          align: 'center',
          value: 'total',
          sortable: true
        },
        {
          text: this.$t('general.status'),
          align: 'center',
          value: 'blackList.status',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false
        }
      ]
    },
    rules () {
      return this.$validationRules()
    }
  },
  methods: {
    changeSort (header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    getTaxResults () {
      if (this.$refs.form.validate()) {
        this.filterDialog = true
        this.cfdisTable = false
        this.$emit('getTaxResults', {taxID: this.searchTax, context: this})
      }
    },
    getGeneralResults () {
      this.filterDialog = true
      // this.cfdisTable = true
      this.$emit('getGeneralResults', {context: this})
    },
    readXmlToHtml (item) {
      this.cfdiDialog = true
      this.$store.dispatch('readXmlToHtml', {
        event: {
          id: item.gst_expenses_items_files[0].files_id,
          context: this
        }
      })
    },
    downloadFile (item) {
      this.loading = true
      this.$emit('downloadFile', { item: item, context: this })
    },
    close () {
      this.filterDialog = false
      this.cfdiDialog = false
      // this.searchTax = ''
      this.cfdiHtml = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/verifyEFOS.component.vue